<template>
  <div id="qrcode-container" class="qrcode-container"></div>
</template>

<script>
  export default {
    data() {
      return {
        ua: navigator.userAgent
      }
    },
    methods: {
      isWeixin() {
        const u = this.ua.toLowerCase()
        if (u.match(/MicroMessenger/i) == 'micromessenger') { return true }
        return false
      },
      isPC() {
        const agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
        let flag = true
        for (let i = 0; i < agents.length; i++) {
          if (this.ua.indexOf(agents[i]) > 0) {
            flag = false
            break
          }
        }
        return flag
      },
      getRealDownloadUrl() {
        if (this.isWeixin()) {
          document.querySelector('#qrcode-container').appendChild(
            document.createTextNode(
              '请点击右上角按钮, 点击使用浏览器打开'
            )
          )
        }
        if (this.isPC()) {
          window.location.href = this.dlUrls.default
        }
      }
    },
    beforeMount() {
      console.log(this.ua)
      this.getRealDownloadUrl()
    }
  }
</script>

<style scoped lang="scss">
.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
</style>
